module.exports = {"510822100":"乔庄镇","510822101":"青溪镇","510822102":"房石镇","510822103":"关庄镇","510822104":"凉水镇","510822105":"竹园镇","510822106":"木鱼镇","510822107":"沙州镇","510822108":"姚渡镇","510822109":"三锅镇","510822111":"建峰镇","510822112":"乐安镇","510822203":"茶坝乡","510822207":"蒿溪回族乡","510822210":"曲河乡","510822212":"石坝乡","510822216":"大院回族乡","510822220":"七佛乡","510822224":"骑马乡","510822225":"观音店乡","510822400":"唐家河国家级自然保护区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510822.json
// module id = 2444
// module chunks = 0